"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/no-unused-modules
function createTitanClient(config_) {
    var _a, _b;
    const config = Object.assign(Object.assign({}, config_), { fetch: (_a = config_.fetch) !== null && _a !== void 0 ? _a : window.fetch.bind(window), anonymousId: (_b = config_.anonymousId) !== null && _b !== void 0 ? _b : getOrCreateAnonymousId() });
    const authHeader = `Basic ${btoa(`${config.sourceWriteKey}:`)}`;
    return {
        track(payload) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                payload.anonymousId = (_a = payload.anonymousId) !== null && _a !== void 0 ? _a : config.anonymousId;
                const url = new URL("/v1/track", config.url);
                const response = yield config.fetch(url, {
                    method: "POST",
                    headers: {
                        Authorization: authHeader,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                assertResponseIsOk(response);
            });
        },
        page(payload) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                payload.anonymousId = (_a = payload.anonymousId) !== null && _a !== void 0 ? _a : config.anonymousId;
                const url = new URL("/v1/page", config.url);
                const response = yield config.fetch(url, {
                    method: "POST",
                    headers: {
                        Authorization: authHeader,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                assertResponseIsOk(response);
            });
        },
    };
}
exports.default = createTitanClient;
function getOrCreateAnonymousId() {
    const key = "narvar_titan_anonymous_id";
    let value = tryGetSessionStorageItem(key);
    if (typeof value === "string") {
        return value;
    }
    value = crypto.randomUUID();
    trySetSessionStorageItem(key, value);
    return value;
}
function tryGetSessionStorageItem(key) {
    try {
        return sessionStorage.getItem(key);
    }
    catch (err) {
        return null;
    }
}
function trySetSessionStorageItem(key, value) {
    try {
        sessionStorage.setItem(key, value);
    }
    catch (err) {
        // no-op
    }
}
function assertResponseIsOk(response) {
    if (!response.ok) {
        throw new Error(`Unexpected response status: ${response.status}`);
    }
}
